import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCredentials } from "../auth/authSlice";
import { useCreateUserMutation } from "../Admin/adminApiSlice";
import { useDuplicateWorkbookMutation } from "../libraryApiSlice";
import { RxCross2 } from "react-icons/rx";
import { FaEye, FaEyeSlash, FaUserAlt } from "react-icons/fa";
import { IoLockClosedOutline } from "react-icons/io5";
import { useLoginMutation } from "./authApiSlice";

const RegisterModal = ({
  workbookid,
  closeModal,
  setUserShouldGoToDashboard,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [passwordError, setPasswordError] = useState("");
  const [loginModal, setLoginModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [loginFormData, setLoginFormData] = useState({
    user: "",
    pwd: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(loginModal);

  // API Hooks
  const [
    createUser,
    {
      data: registeredData,
      isError: isRegisterError,
      isSuccess: isRegistered,
      error: registerError,
    },
  ] = useCreateUserMutation();
  const [
    duplicateWorkbook,
    {
      data: duplicateData,
      isLoading: isWorkbookDuplicating,
      isSuccess: isWorkbookDuplicated,
      isError: workbookDuplicated,
      error: errorDuplicatingWorkbook,
    },
  ] = useDuplicateWorkbookMutation();

  const [login, { data, isLoading, isError, isSuccess, error }] =
    useLoginMutation();

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPasswordError("");

    if (formData.password !== formData.confirmPassword) {
      setPasswordError("Passwords do not match.");
      return;
    }

    const { name, email, password } = formData;

    try {
      // Register user and get token
      const registeredData = await createUser({
        username: email,
        password,
        email,
        name,
        roles: "Creator",
        loginAlso: true,
      }).unwrap();

      const { accessToken } = registeredData;
      dispatch(setCredentials({ accessToken }));

      // Duplicate workbook
      const duplicateData = await duplicateWorkbook(workbookid).unwrap();
      if (duplicateData?.newWorkbookId) {
        navigate(
          `/workbook?workbookid=${duplicateData.newWorkbookId}&tutorial=true`
        );
      }
    } catch (error) {
      console.error("Error during registration or duplication:", error);
    } finally {
    }
  };

  const handleLoginInputChange = (e) => {
    setLoginFormData({ ...loginFormData, [e.target.name]: e.target.value });
  };
  const handleLogin = async () => {
    const userData = await login({
      user: loginFormData.user,
      pwd: loginFormData.pwd,
    }).unwrap();
    const { accessToken } = userData;
    dispatch(setCredentials({ accessToken }));
    const accessTokenData = { accessToken };
    localStorage.setItem("accessTokenData", JSON.stringify(accessTokenData));
    // Duplicate workbook
    duplicateWorkbook(workbookid);
  };
  useEffect(() => {
    console.log(duplicateData);
    if (duplicateData && duplicateData?.newWorkbookId) {
      console.log(duplicateData);
      navigate(`/workbook?workbookid=${duplicateData.newWorkbookId}`);
    }
  }, [isWorkbookDuplicated, duplicateData]);

  return (
    <main className="fixed inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
      {loginModal ? (
        // login modal
        <main className="flex flex-col bg-white shadow-md rounded-lg overflow-hidden w-[90%] sm:w-[60%] md:w-[40%] lg:w-[25%] h-auto mx-auto">
          {/* Header Section */}
          <header className="bg-gray-50 w-full flex justify-between items-center p-1 sm:p-2 md:p-3 font-semibold">
            Login
            <RxCross2
              onClick={closeModal}
              className="cursor-pointer text-black text-lg sm:text-xl"
            />
          </header>

          {/* Form Section */}
          <section className="flex flex-col justify-center items-center w-full p-1 sm:p-2 md:p-3 gap-3">
            {/* Logo */}
            <img
              src="/assets/viz.png"
              alt="Logo"
              className="w-1/2 sm:w-1/3 md:w-1/4"
            />

            {/* Status Messages */}
            {isWorkbookDuplicating && (
              <p className="text-green-500 text-sm sm:text-base">
                Login successful! Duplicating workbook...
              </p>
            )}
            {isWorkbookDuplicated && (
              <p className="text-green-500 text-sm sm:text-base">
                Workbook duplicated successfully!
              </p>
            )}
            {isError && (
              <p className="text-red-500 text-sm sm:text-base">{error.data}</p>
            )}
            {workbookDuplicated && (
              <p className="text-red-500 text-sm sm:text-base">
                There is an issue duplicating the workbook, try again later.
              </p>
            )}

            {/* Username Input */}
            <div className="relative w-full">
              <FaUserAlt className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500 text-sm sm:text-base" />
              <input
                onChange={handleLoginInputChange}
                value={loginFormData.user}
                name="user"
                className="text-base rounded border border-gray-300 px-10 py-2 w-full focus:outline-none"
                type="text"
                placeholder="Enter your username"
              />
            </div>

            {/* Password Input */}
            <div className="relative w-full">
              <IoLockClosedOutline className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-500 text-sm sm:text-base" />
              <input
                type={showPassword ? "text" : "password"}
                onChange={handleLoginInputChange}
                value={loginFormData.pwd}
                name="pwd"
                className="text-base rounded border border-gray-300 px-10 py-2 w-full focus:outline-none"
                placeholder="Enter your password"
              />
              <span
                className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer"
                onClick={handleTogglePasswordVisibility}
              >
                {showPassword ? (
                  <FaEyeSlash className="text-gray-500" />
                ) : (
                  <FaEye className="text-gray-500" />
                )}
              </span>
            </div>

            {/* Bottom Section */}
            <div className="flex flex-col sm:flex-row items-center justify-between w-full">
              <button
                className="text-blue-500 font-light hover:underline text-sm sm:text-base"
                onClick={() => setLoginModal(false)}
              >
                Don't have an account?
              </button>

              <div className="flex items-center justify-end gap-3 sm:gap-4 mt-2 sm:mt-0">
                <button
                  className="border px-3 py-1 rounded text-sm sm:text-base"
                  type="button"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button
                  className="border bg-blue-950 text-white px-3 py-1 rounded text-sm sm:text-base"
                  onClick={handleLogin}
                >
                  {isLoading ? "Logging in..." : "Login"}
                </button>
              </div>
            </div>
          </section>
        </main>
      ) : (
        // register modal
        <main className="flex flex-col bg-white shadow-md rounded-lg overflow-hidden w-[90%] sm:w-[60%] md:w-[40%] lg:w-[25%] h-auto mx-auto">
          <header className="bg-gray-50 w-full justify-between items-center p-2 font-semibold flex">
            Create a new account
            <RxCross2
              onClick={closeModal}
              className="cursor-pointer text-black"
            />
          </header>
          <section className="flex flex-col justify-center items-center w-full p-4">
            <img src="/assets/viz.png" alt="Logo" className="w-1/2" />

            {isRegistered && (
              <p className="text-green-500 text-center">
                Registration successful! Duplicating workbook...
              </p>
            )}
            {isWorkbookDuplicated && (
              <p className="text-green-500 text-center">
                Workbook duplicated successfully!
              </p>
            )}
            {passwordError && (
              <p className="text-red-500 text-center">{passwordError}</p>
            )}
            {isRegisterError && (
              <p className="text-red-500 text-center">
                There is an error creating the account. Try again later.
              </p>
            )}

            <form
              onSubmit={handleSubmit}
              className="w-full flex flex-col gap-4 items-start"
            >
              <div className="w-full flex flex-col gap-2">
                <label htmlFor="name" className="font-semibold text-left">
                  Full Name:
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="rounded border border-gray-300 px-3 py-2 w-full focus:outline-none"
                  placeholder="Enter your full name"
                />
              </div>

              <div className="w-full flex flex-col gap-2">
                <label htmlFor="email" className="font-semibold text-left">
                  Email Address:
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="rounded border border-gray-300 px-3 py-2 w-full focus:outline-none"
                  placeholder="Enter your email address"
                />
              </div>

              <div className="w-full flex flex-col gap-2">
                <label htmlFor="password" className="font-semibold text-left">
                  Password:
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="rounded border border-gray-300 px-3 py-2 w-full focus:outline-none"
                  placeholder="Enter your password"
                />
              </div>

              <div className="w-full flex flex-col gap-2">
                <label
                  htmlFor="confirmPassword"
                  className="font-semibold text-left"
                >
                  Confirm Password:
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className="rounded border border-gray-300 px-3 py-2 w-full focus:outline-none"
                  placeholder="Confirm your password"
                />
              </div>

              <div className="flex flex-col md:flex-row items-center justify-between w-full gap-2">
                <button
                  className="text-blue-500 font-light hover:underline"
                  onClick={() => setLoginModal(true)}
                >
                  Already a user?
                </button>
                <div className="flex items-center justify-end gap-4 w-full md:w-auto">
                  <button
                    className="border px-3 py-2 rounded w-full md:w-auto"
                    type="button"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="border bg-blue-950 text-white px-3 py-2 rounded w-full md:w-auto"
                    type="submit"
                  >
                    Register
                  </button>
                </div>
              </div>
            </form>
          </section>
        </main>
      )}
    </main>
  );
};

export default RegisterModal;
